import { ICountHub } from '@/services';
import { injectable, inject } from 'inversify-props';
import { MealCountKey } from '@/models';
import {
  SyncMealsDownCommand,
  SyncAllLocalMealsDownCommand,
  SyncMealsUpCommand,
  MergeServingLinesCommand } from './commands';
import { mcLogger } from '@/utils';

export interface ISyncService {
  syncMealsDown(mealCountKeys: MealCountKey[]): any;
  syncAllLocalMealsDown(): any;
  syncUp(): Promise<any>;
  mergeServingLines(): any;

  joinSignalRGroup(groupId:string): void;
  leaveSignalRGroup(groupId:string): void;
}

@injectable()
export class SyncService implements ISyncService {
  private readonly console = mcLogger.getConsole(this.constructor.name, mcLogger.colors.SyncService);
  private readonly syncAllMealsDownCmd = new SyncAllLocalMealsDownCommand();
  @inject() private readonly countHub!: ICountHub;

  /** Syncs down all server counts that exist locally. */
  async syncAllLocalMealsDown() {
    return this.syncAllMealsDownCmd.run();
  }

  private readonly syncMealsDownCmd = new SyncMealsDownCommand();

  /**
   * Syncs requested meals down from server.
   * @param mealCountKeys
   */
  async syncMealsDown(mealCountKeys: MealCountKey[]) {
    return this.syncMealsDownCmd.run(mealCountKeys);
  }

  private readonly syncMealsUpCmd = new SyncMealsUpCommand();
  async syncUp() {
    return this.syncMealsUpCmd.run();
  }

  async joinSignalRGroup(groupId:string) {
    if (groupId) {
      await this.countHub.joinGroupAsync(groupId);
    } else {
      this.console.warn('The given Group Id is empty, unable to join!');
    }
  }

  async leaveSignalRGroup(groupId:string) {
    if (groupId) {
      await this.countHub.leaveGroupAsync(groupId);
    } else {
      this.console.warn('The given Group Id is empty, unable to leave!');
    }
  }

  private readonly mergeServingLinesCmd = new MergeServingLinesCommand();
  async mergeServingLines() {
    return this.mergeServingLinesCmd.run();
  }
}
